import { useState, useEffect, useMemo } from 'react'
import Portal from './portal'
import { isLocalhost, portalHost } from '../environment'
import styles from './meshsite.module.css'
import { MeshAppBridge } from '../meshAppBridge/bridge'

type Props = {
  bridge: MeshAppBridge
}

export default function MeshSite({ bridge }: Props) {
  const [loadSiteName, setLoadSiteName] = useState<string>('')

  useEffect(() => {
    const path = window.location.pathname
    setLoadSiteName(path)
  }, [])

  const loadSiteURL = useMemo(() => {
    if (isLocalhost) {
      return `${portalHost}/site`
    }
    return loadSiteName
      ? `${portalHost}/iframe.html#site=${encodeURIComponent(loadSiteName)}`
      : ''
  }, [loadSiteName])

  console.log('Load site URL: ' + loadSiteURL)

  return (
    <div className={styles.meshsite}>
      {loadSiteName && <Portal bridge={bridge} loadSiteName={loadSiteURL} />}
    </div>
  )
}
